module.exports = __webpack_public_path__ + "img/dy.e16be987.png";